
import { getStorage, ref, getDownloadURL } from "firebase/storage";

export const getInvitationCardDownloadURL = async (path: string) => {
    return getDownloadURL(ref(getStorage(), process.env.REACT_APP_FIREBASE_STORAGE_INVITATION_CARDS_PATH + path));
}
